var React = require('react');

function RightTriangleCustomers (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.4"},[React.createElement("path",{"d":"M296.016 152.068L163.701 380.76L8.57634 0.000174986L296.016 152.068Z","fill":"#E5E5E5","key":0}),React.createElement("path",{"d":"M561.731 158.458L163.248 380.75L295.511 152.404L561.731 158.458Z","fill":"#D9D8D8","key":1}),React.createElement("path",{"d":"M561.73 158.458L295.698 152.408L8.5741 0.000569863L561.73 158.458Z","fill":"#E0DFDF","key":2})]));
}

RightTriangleCustomers.defaultProps = {"width":"566","height":"390","viewBox":"0 0 566 390","fill":"none"};

module.exports = RightTriangleCustomers;

RightTriangleCustomers.default = RightTriangleCustomers;
